import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, } from '@angular/router';
import { devices } from './data';
import { DeviceData } from './model';
import { Chart, ChartConfiguration, ChartData, ChartType } from 'chart.js/auto';



@Component({
    selector: 'app-group-energy-stats',
    templateUrl: './group-energy-stats.component.html',
    styleUrls: ['./group-energy-stats.component.scss'],
    standalone: false
})
export class GroupEnergyStatsComponent implements OnInit {

  @Input() dataGroup: any;
  @Input() loading: boolean;

  groupId: string = '';
  subgroupsExpanded: boolean = false;
  chargersExpanded: boolean = false;
  isAllSelected: boolean = false;
  isIndeterminate: boolean = false;
  currentView: 'list' | 'grid' = 'list';

  subgroups: any[] = [];
  selectedDevice: DeviceData | null = null;
  selectedDeviceIds: string[] = [];
  allDevices: DeviceData[] = [];
  resumeDevices: any[] = [];
  resumeTotalKwh: number = 0;

  data: DeviceData[];

  // Propiedades para filtros de tiempo
  priceKwh: number = 0.15;
  activeFilter: string = '30days';
  customStartDate: string = '';
  customEndDate: string = '';

  // Propiedades para filtros
  filteredDevices: DeviceData[] = [];
  // searchTerm: string = '';
  // statusFilter: string = 'all'; // 'all', 'online', 'offline'
  // typeFilter: string = 'all'; // 'all', 'XEO', 'EVVC', 'ANC', etc.
  // Propiedades para filtros (agregar tipos)
  selectedDeviceType: string = '';
  selectedFirmwareVersion: string = '';
  selectedConnectionStatus: string = '';
  availableFirmwareVersions: string[] = [];

  // Propiedades para el gráfico
  currentChartType: 'bar' | 'doughnut' = 'bar';


  public chartData: ChartData<'bar'> = {
    labels: [],
    datasets: [{
      label: 'Energía (kWh)',
      data: [], // Datos de ejemplo
      backgroundColor: [
        'rgba(54, 162, 235, 0.7)',
        'rgba(255, 99, 132, 0.7)',
        'rgba(255, 205, 86, 0.7)',
        'rgba(75, 192, 192, 0.7)',
        'rgba(153, 102, 255, 0.7)',
        'rgba(255, 159, 64, 0.7)'
      ],
      borderColor: [
        'rgba(54, 162, 235, 1)',
        'rgba(255, 99, 132, 1)',
        'rgba(255, 205, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)'
      ],
      borderWidth: 1,
      borderRadius: 4
    }]
  };

  public chartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y', // Esto hace que sea horizontal
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            return `${context.parsed.x.toFixed(2)} kWh`;
          }
        }
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Energía (kWh)'
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.1)'
        }
      },
      y: {
        title: {
          display: true,
          text: 'Dispositivos'
        },
        grid: {
          display: false
        }
      }
    }
  };

  public chartType: ChartType = 'bar';

  @ViewChild('chartCanvas', { static: false }) chartCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('deviceHistoryChart', { static: false }) deviceHistoryChart!: ElementRef<HTMLCanvasElement>;
  private chart: Chart | null = null;
  private historyChart: Chart | null = null;
  selectedHistoryChart: 'energy' | 'power' | 'voltage' = 'energy';


  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.groupId = params['id'] || '';


if (this.dataGroup && this.dataGroup.devices) {
        localStorage.setItem('dataStats', JSON.stringify(this.dataGroup));


}else {
      const storedData = localStorage.getItem('dataStats');
      if (storedData) {
        this.dataGroup = JSON.parse(storedData);
      } else {
        console.error('No data found in localStorage for dataStats');
        return;
      }
    }

      console.log('data group ',this.dataGroup);
      if (this.dataGroup && this.dataGroup.devices) {
       this.data = this.formatData(this.dataGroup.devices);

       console.log('data total **** ', this.data);
      }

      this.extractDeviceTypes(); // Solo extraer tipos disponibles

      this.loadData();
      this.chartData = {
        ...this.chartData,
        datasets: [{
          ...this.chartData.datasets[0],
          data: this.data.map(device => (device.totalEnergy || 0))
        }]
      }
    });
  }

  ngAfterViewInit(): void {
    // Pequeño delay para asegurar que el canvas esté renderizado
    setTimeout(() => {
      this.initChart();
    }, 100);
  }

private initChart(): void {
  if (this.chartCanvas && this.chartCanvas.nativeElement) {
    const ctx = this.chartCanvas.nativeElement.getContext('2d');
    if (ctx) {
      // USAR resumeDevices en lugar de this.data
      const devicesToShow = this.resumeDevices.length > 0 ? this.resumeDevices : [];

      // Generar colores dinámicamente según los dispositivos seleccionados
      const colors = this.generateColors(devicesToShow.length);

      const chartConfig: any = {
        type: this.currentChartType,
        data: {
          labels: devicesToShow.map(device => device.name || device.serial),
          datasets: [{
            label: this.currentChartType === 'bar' ? 'Energía (kWh)' : 'Proporción de energía',
            data: devicesToShow.map(device => (device.totalEnergy || 0)),
            backgroundColor: colors.backgrounds,
            borderColor: colors.borders,
            borderWidth: this.currentChartType === 'bar' ? 1 : 2,
            borderRadius: this.currentChartType === 'bar' ? 4 : 0
          }]
        },
        options: this.getChartOptions()
      };

      this.chart = new Chart(ctx, chartConfig);
      console.log('Chart initialized with selected devices:', devicesToShow);
    }
  }
}

  private getChartOptions(): any {
    const baseOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: this.currentChartType === 'doughnut',
          position: this.currentChartType === 'doughnut' ? 'right' : 'top'
        },
        tooltip: {
          callbacks: {
            label: (context) => {
              if (this.currentChartType === 'doughnut') {
                const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
                const percentage = ((context.parsed / total) * 100).toFixed(1);
                return `${context.label}: ${context.parsed.toFixed(2)} kWh (${percentage}%)`;
              } else {
                return `${context.parsed.x.toFixed(2)} kWh`;
              }
            }
          }
        }
      }
    };

    if (this.currentChartType === 'bar') {
      return {
        ...baseOptions,
        indexAxis: 'y',
        scales: {
          x: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Energía (kWh)'
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.1)'
            }
          },
          y: {
            title: {
              display: true,
              text: 'Dispositivos'
            },
            grid: {
              display: false
            }
          }
        }
      };
    } else {
      return baseOptions; // Doughnut no necesita scales
    }
  }

    private generateColors(count: number): { backgrounds: string[], borders: string[] } {
    const baseColors = [
      [54, 162, 235],   // Azul
      [255, 99, 132],   // Rojo/Rosa
      [255, 205, 86],   // Amarillo
      [75, 192, 192],   // Verde/Cyan
      [153, 102, 255],  // Púrpura
      [255, 159, 64],   // Naranja
      [201, 203, 207],  // Gris
      [83, 102, 255],   // Azul índigo
      [255, 99, 255],   // Magenta
      [99, 255, 132],   // Verde lima
      [255, 192, 99],   // Naranja claro
      [132, 99, 255]    // Violeta
    ];

    const backgrounds: string[] = [];
    const borders: string[] = [];

    for (let i = 0; i < count; i++) {
      if (i < baseColors.length) {
        const [r, g, b] = baseColors[i];
        backgrounds.push(`rgba(${r}, ${g}, ${b}, 0.7)`);
        borders.push(`rgba(${r}, ${g}, ${b}, 1)`);
      } else {
        const hue = (i * 360 / count) % 360;
        backgrounds.push(`hsla(${hue}, 65%, 60%, 0.7)`);
        borders.push(`hsla(${hue}, 65%, 60%, 1)`);
      }
    }

    return { backgrounds, borders };
  }

  private updateChart(): void {
    if (!this.chart) {
      console.log('Chart not initialized yet');
      return;
    }

    if (this.resumeDevices.length === 0) {
      this.chart.data.labels = [];
      this.chart.data.datasets[0].data = [];
    } else {
      const sortedDevices = [...this.resumeDevices].sort((a, b) =>
        (b.totalEnergy || 0) - (a.totalEnergy || 0)
      );

      const colors = this.generateColors(sortedDevices.length);

      this.chart.data.labels = sortedDevices.map(device => device.name || device.serial);
      this.chart.data.datasets[0].data = sortedDevices.map(device => (device.totalEnergy || 0));
      this.chart.data.datasets[0].backgroundColor = colors.backgrounds;
      this.chart.data.datasets[0].borderColor = colors.borders;
    }

    this.chart.update('active');
  }

  ngOnDestroy(): void {
    this.destroyChart();
  }

  private loadData(): void {
    // Mantener la información existente y agregar los datos de devices
    if (this.data && this.data.length > 0) {
      this.data = [ ...this.data];
    } else {
      this.data = devices;
    }
    this.allDevices = this.data;
    this.filteredDevices = [...this.allDevices];
    this.availableFirmwareVersions = this.extractFirmwareVersions();
    console.log('all devices data ', this.allDevices);

    // Seleccionar todos los dispositivos por defecto
    this.selectedDeviceIds = this.filteredDevices
      .map((device) => device.serial)
      .filter((id): id is string => id !== undefined);

    // Marcar el checkbox "Seleccionar todos" como seleccionado
    this.isAllSelected = true;
    this.isIndeterminate = false;

    // Actualizar los dispositivos filtrados
    this.updateFilteredDevices();
    this.applyFilters();

    console.log('Data loaded with all devices selected:', this.data);
    console.log('Selected device IDs:', this.selectedDeviceIds);
  }

  toggleAccordion(section: string): void {
    if (section === 'subgroups') {
      this.subgroupsExpanded = !this.subgroupsExpanded;
    } else if (section === 'chargers') {
      this.chargersExpanded = !this.chargersExpanded;
    }
  }

  onSelectAllChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const selectAll = input.checked;

    const visibleIds = this.filteredDevices
      .map(device => device.serial)
      .filter((id): id is string => !!id);

    if (selectAll) {
      const combinedSelection = new Set(this.selectedDeviceIds);
      visibleIds.forEach(id => combinedSelection.add(id));
      this.selectedDeviceIds = Array.from(combinedSelection);
    } else {
      const visibleIdSet = new Set(visibleIds);
      this.selectedDeviceIds = this.selectedDeviceIds.filter(id => !visibleIdSet.has(id));
    }

    this.updateSelectAllState();
    this.updateFilteredDevices();
  }

  isDeviceSelected(serial: string | undefined): boolean {
    return this.selectedDeviceIds.includes(serial);
  }
  onDeviceSelectionChange(event: Event, serial: string | undefined): void {
    const input = event.target as HTMLInputElement;
    const isChecked = input.checked;

    if (isChecked) {
      if (serial && !this.selectedDeviceIds.includes(serial)) {
        this.selectedDeviceIds.push(serial);
      }
    } else {
      this.selectedDeviceIds = this.selectedDeviceIds.filter(id => id !== serial);
    }

    this.updateFilteredDevices();
    this.updateSelectAllState(); // Actualizar el estado del checkbox "Seleccionar todos"
  }


  private updateSelectAllState(): void {
    const visibleIds = this.filteredDevices
      .map(device => device.serial)
      .filter((id): id is string => !!id);
    const totalDevices = visibleIds.length;

    if (totalDevices === 0) {
      this.isAllSelected = false;
      this.isIndeterminate = false;
      return;
    }

    const selectedCount = visibleIds.filter(id => this.selectedDeviceIds.includes(id)).length;

    if (selectedCount === 0) {
      this.isAllSelected = false;
      this.isIndeterminate = false;
    } else if (selectedCount === totalDevices) {
      this.isAllSelected = true;
      this.isIndeterminate = false;
    } else {
      this.isAllSelected = false;
      this.isIndeterminate = true; // Estado intermedio (algunos seleccionados)
    }
  }

  // Métodos para obtener estadísticas agregadas de dispositivos seleccionados
  getTotalSelectedEnergy(): number {
    return this.resumeDevices.reduce((total, device) => total + (device.totalEnergy || 0), 0);
  }

  getAveragePower(): number {
    if (this.resumeDevices.length === 0) return 0;
    const totalPower = this.resumeDevices.reduce((total, device) => total + (device.power || 0), 0);
    return totalPower / this.resumeDevices.length;
  }

  getTotalCurrentPower(): number {
    return this.resumeDevices.reduce((total, device) => total + (device.power || 0), 0);
  }

  getSelectedDeviceTypes(): { [key: string]: number } {
    const types: { [key: string]: number } = {};
    this.resumeDevices.forEach(device => {
      let deviceType = device.type;

      // Si no tiene tipo definido, determinarlo por el serial
      if (!deviceType) {
        if (device.serial.includes('XEO')) {
          deviceType = 'XEO';
        } else if (device.serial.includes('ANC')) {
          deviceType = 'ANC';
        } else if (device.serial.includes('EVVC1')) {
          deviceType = 'EVVC1';
        } else if (device.serial.includes('EVVC3')) {
          deviceType = 'EVVC3';
        } else if (device.serial.includes('EVVC4')) {
          deviceType = 'EVVC4';
        } else if (device.serial.includes('EVVC5')) {
          deviceType = 'EVVC5';
        } else if (device.serial.includes('EVVC6')) {
          deviceType = 'EVVC6';
        } else {
          deviceType = 'Desconocido';
        }
      }

      types[deviceType] = (types[deviceType] || 0) + 1;
    });
    return types;
  }

  getSelectedDeviceTypesText(): string {
    if (this.resumeDevices.length === 0) {
      return 'Sin selección';
    }

    const types = this.getSelectedDeviceTypes();
    if (Object.keys(types).length === 0) {
      return 'Sin tipos definidos';
    }

    const typeStrings = Object.entries(types).map(([type, count]) => {
      const typeDisplay = this.getDisplayNameForType(type);
      return count === 1 ? `${count} ${typeDisplay}` : `${count} ${typeDisplay}s`;
    });

    return typeStrings.join(' • ');
  }

  private getDisplayNameForType(type: string): string {
    const typeMap: { [key: string]: string } = {
      'XEO': 'XeoLum+',
      'ANC': 'AstroNovaCity',
      'EVVC1': 'Combi',
      'EVVC3': 'Uni',
      'EVVC4': 'CombiPlus',
      'EVVC5': 'City+2',
      'EVVC6': 'Exo',
      'Desconocido': 'Desconocido'
    };
    return typeMap[type] || type;
  }

  getTotalMaxPower(): number {
    return this.resumeDevices.reduce((total, device) => {
      // Intentar obtener maxPower del historial más reciente
      if (device.history?.maxPower?.values && device.history.maxPower.values.length > 0) {
        const latestMaxPower = device.history.maxPower.values[device.history.maxPower.values.length - 1];
        return total + (latestMaxPower || 0);
      }
      // Si no hay historial, usar la potencia actual como aproximación
      return total + (device.power || 0);
    }, 0);
  }

  onViewChange(view: 'list' | 'grid'): void {
    this.currentView = view;
  }

  openDeviceInfoModal(device: DeviceData): void {
    this.selectedDevice = device;
    console.log('Opening device info modal for:', device);
  }

  openDeviceStatsModal(device: DeviceData): void {
    this.selectedDevice = device;
    console.log('Opening device stats modal for:', device);

    // Inicializar el gráfico después de un pequeño delay para asegurar que el DOM esté listo
    setTimeout(() => {
      this.createHistoryChart();
    }, 300);
  }

  changeHistoryChart(type: 'energy' | 'power' | 'voltage'): void {
    this.selectedHistoryChart = type;
    this.createHistoryChart();
  }

  createHistoryChart(): void {
    if (!this.selectedDevice || !this.deviceHistoryChart?.nativeElement) {
      return;
    }

    // Verificar si el dispositivo tiene historial
    if (!this.selectedDevice.history) {
      console.log('Device does not have history data');
      return;
    }

    // Destruir el gráfico anterior si existe
    if (this.historyChart) {
      this.historyChart.destroy();
    }

    const ctx = this.deviceHistoryChart.nativeElement.getContext('2d');
    if (!ctx) return;

    let chartData: { values: number[]; labels: string[] };
    let label: string;
    let color: string;
    let datasets: any[] = [];

    // Seleccionar los datos según el tipo de gráfico
    switch (this.selectedHistoryChart) {
      case 'energy':
        chartData = this.selectedDevice.history.energy;
        label = 'Energía (kWh)';
        color = 'rgba(54, 162, 235, 0.8)';

        // Barras para energía
        datasets.push({
          type: 'bar',
          label: label,
          data: chartData.values,
          backgroundColor: color,
          borderColor: color.replace('0.8', '1'),
          borderWidth: 1,
          borderRadius: 4,
          yAxisID: 'y'
        });

        // Calcular la media de energía
        const energyAverage = chartData.values.reduce((sum, val) => sum + val, 0) / chartData.values.length;
        const averageData = new Array(chartData.values.length).fill(energyAverage);

        // Línea de media
        datasets.push({
          type: 'line',
          label: `Media (${energyAverage.toFixed(2)} kWh)`,
          data: averageData,
          backgroundColor: 'rgba(75, 192, 192, 0.1)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 2,
          borderDash: [5, 5], // Línea discontinua
          fill: false,
          tension: 0,
          pointRadius: 0,
          pointHoverRadius: 0,
          yAxisID: 'y'
        });
        break;

      case 'power':
        chartData = this.selectedDevice.history.averageMaxPowerDemand;
        label = 'Potencia Media (W)';
        color = 'rgba(255, 99, 132, 0.8)';

        // Dataset de barras para potencia media
        datasets.push({
          type: 'bar',
          label: label,
          data: chartData.values,
          backgroundColor: color,
          borderColor: color.replace('0.8', '1'),
          borderWidth: 1,
          borderRadius: 4,
          yAxisID: 'y'
        });

        // Dataset de línea para maxPower
        datasets.push({
          type: 'line',
          label: 'Potencia Máxima (W)',
          data: this.selectedDevice.history.maxPower.values,
          backgroundColor: 'rgba(255, 159, 64, 0.1)',
          borderColor: 'rgba(255, 159, 64, 1)',
          borderWidth: 3,
          fill: false,
          tension: 0.4,
          pointRadius: 4,
          pointHoverRadius: 7,
          pointBackgroundColor: 'rgba(255, 159, 64, 1)',
          pointBorderColor: '#fff',
          pointBorderWidth: 2,
          yAxisID: 'y'
        });
        break;

      case 'voltage':
        chartData = this.selectedDevice.history.averageVoltage;
        label = 'Voltaje (V)';
        color = 'rgba(75, 192, 192, 0.8)';

        // Solo barras para voltaje
        datasets.push({
          type: 'bar',
          label: label,
          data: chartData.values,
          backgroundColor: color,
          borderColor: color.replace('0.8', '1'),
          borderWidth: 1,
          borderRadius: 4,
          yAxisID: 'y'
        });
        break;
    }

    this.historyChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: chartData.labels,
        datasets: datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'top',
            labels: {
              usePointStyle: true,
              padding: 15
            }
          },
          tooltip: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: (context) => {
                const value = context.parsed.y;
                const datasetLabel = context.dataset.label || '';
                return `${datasetLabel}: ${value.toFixed(2)}`;
              }
            }
          }
        },
        scales: {
          y: {
            type: 'linear',
            display: true,
            position: 'left',
            beginAtZero: true,
            title: {
              display: true,
              text: label
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.1)'
            }
          },
          x: {
            title: {
              display: true,
              text: 'Tiempo'
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }
        },
        interaction: {
          mode: 'index',
          intersect: false
        }
      }
    });
  }

  exportDeviceHistory(): void {
    if (!this.selectedDevice || !this.selectedDevice.history) return;

    // Crear datos CSV
    const headers = ['Fecha', 'Energía (kWh)', 'Potencia Media (W)', 'Potencia Máxima (W)', 'Voltaje (V)'];
    const rows: string[] = [headers.join(',')];

    const maxLength = Math.max(
      this.selectedDevice.history.energy.labels.length,
      this.selectedDevice.history.averageMaxPowerDemand.labels.length,
      this.selectedDevice.history.maxPower.labels.length,
      this.selectedDevice.history.averageVoltage.labels.length
    );

    for (let i = 0; i < maxLength; i++) {
      const date = this.selectedDevice.history.energy.labels[i] || '';
      const energy = this.selectedDevice.history.energy.values[i] || 0;
      const avgPower = this.selectedDevice.history.averageMaxPowerDemand.values[i] || 0;
      const maxPower = this.selectedDevice.history.maxPower.values[i] || 0;
      const voltage = this.selectedDevice.history.averageVoltage.values[i] || 0;

      rows.push(`${date},${energy.toFixed(2)},${avgPower.toFixed(2)},${maxPower.toFixed(2)},${voltage.toFixed(2)}`);
    }

    // Crear y descargar el archivo
    const csvContent = rows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', `${this.selectedDevice.serial}_history.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  // Método para obtener array de salidas para el ngFor
  getOutputsArray(): any[] {
    if (!this.selectedDevice?.schedule) {
      return [];
    }

    return [
      this.selectedDevice.schedule.out1,
      this.selectedDevice.schedule.out2
    ].filter(output => output !== undefined);
  }

  updateFilteredDevices(): void {
    // Usar los dispositivos filtrados en lugar de todos los dispositivos
    this.resumeDevices = this.filteredDevices.filter(device => this.selectedDeviceIds.includes(device.serial));
    this.resumeTotalKwh = this.resumeDevices.reduce((sum, device) => sum + (device.totalEnergy || 0), 0);
    console.log('Filtered devices:', this.resumeDevices);

    // Actualizar el gráfico
    this.updateChart();
  }

    // Método para cambiar el tipo de gráfico
  switchChartType(type: 'bar' | 'doughnut'): void {
    this.currentChartType = type;
    this.destroyChart();
    setTimeout(() => {
      this.initChart();
    }, 100);
  }

    private destroyChart(): void {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }


  getStatusClass(status: number | boolean): string {
    if (status === 1 || status === true) {
      return 'status-active';
    } else {
      return 'status-inactive';
    }
  }

  getStatusText(status): string {
    if (status === 1 || status === true) {
      return 'online';
    } else {
      return 'offline';
    }
  }

  getOnlineDevicesCount(): number {
    return this.resumeDevices.filter(device => device.alive === 1 || device.alive === true).length;
  }

    // Extraer tipos de dispositivos disponibles
  private extractDeviceTypes(): string[] {
    const types = this.allDevices
      .map(device => {
        if (device.serial?.includes('XEO')) return 'XEO';
        if (device.serial?.includes('EVVC')) return 'EVVC';
        if (device.serial?.includes('ANC')) return 'ANC';
        if (device.type) return device.type;
        return 'Otro';
      })
      .filter((type, index, array) => array.indexOf(type) === index) // Únicos
      .sort();

    console.log('Available device types:', types);
    return types;
  }

  private extractFirmwareVersions(): string[] {
    const versions = Array.from(
      new Set(
        this.allDevices
          .map(device => device.fw?.trim())
          .filter((fw): fw is string => !!fw && fw.length > 0)
      )
    );

    return versions.sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));
  }

  applyFilters(): void {
    if (!this.allDevices || this.allDevices.length === 0) {
      this.filteredDevices = [];
      this.isAllSelected = false;
      this.isIndeterminate = false;
      return;
    }

    let filtered = [...this.allDevices];

    if (this.selectedDeviceType) {
      const typeFilter = this.selectedDeviceType.toUpperCase();
      filtered = filtered.filter(device => {
        const serial = device.serial?.toUpperCase() || '';
        const type = device.type?.toUpperCase() || '';
        return serial.includes(typeFilter) || type === typeFilter;
      });
    }

    if (this.selectedFirmwareVersion) {
      filtered = filtered.filter(device => device.fw === this.selectedFirmwareVersion);
    }

    if (this.selectedConnectionStatus !== '') {
      const shouldBeOnline = this.selectedConnectionStatus === 'true';
      filtered = filtered.filter(device => {
        const aliveValue = `${device.alive}`;
        const isAlive = aliveValue === 'true' || aliveValue === '1';
        return isAlive === shouldBeOnline;
      });
    }

    this.filteredDevices = filtered;

    // Actualizar selectedDeviceIds para que solo incluya dispositivos filtrados
    this.selectedDeviceIds = this.selectedDeviceIds.filter(id =>
      this.filteredDevices.some(device => device.serial === id)
    );

    this.updateSelectAllState();
    this.updateFilteredDevices();
  }

  hasActiveFilters(): boolean {
    return this.selectedDeviceType !== '' ||
      this.selectedFirmwareVersion !== '' ||
      this.selectedConnectionStatus !== '';
  }

  clearFilters(): void {
    this.selectedDeviceType = '';
    this.selectedFirmwareVersion = '';
    this.selectedConnectionStatus = '';
    this.applyFilters();
  }

  getDaysFromMask(mask: number): string[] {
  const names = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
  const days: string[] = [];

  for (let i = 0; i < 7; i++) {
    if (mask & (1 << i)) days.push(names[i]);
  }

  return days;
}

  /**
   * Verifica si un día específico está activo en el bitmask
   * @param mask - Bitmask de días (1=L, 2=M, 4=X, 8=J, 16=V, 32=S, 64=D)
   * @param dayBit - Bit del día a verificar (1, 2, 4, 8, 16, 32, 64)
   * @returns true si el día está activo, false en caso contrario
   */
  isDayActive(mask: number, dayBit: number): boolean {
    return (mask & dayBit) !== 0;
  }

  // Métodos para el componente de filtros de tiempo
  onFilterChange(filter: string): void {
    this.activeFilter = filter;
    console.log('Filter changed to:', filter);
    // Aquí puedes añadir lógica para recargar datos según el filtro seleccionado
  }

  onCustomDateChange(dates: { start: string; end: string }): void {
    this.customStartDate = dates.start;
    this.customEndDate = dates.end;
    console.log('Custom dates changed:', dates);
    // Aquí puedes añadir lógica para recargar datos con las fechas personalizadas
  }

  savePrice(): void {
    console.log('Price saved:', this.priceKwh);
    // Aquí puedes añadir lógica para guardar el precio en localStorage o backend
    localStorage.setItem('priceKwh', this.priceKwh.toString());
  }

  onMonthSelected(monthData: { year: number; month: number }): void {
    console.log('Month selected:', monthData);
    // Aquí puedes añadir lógica para filtrar datos por el mes seleccionado
  }


  formatData(dataGroup: any): DeviceData[] {
    return dataGroup?.map(item => ({
      serial: item.serial,
      name: item.name,
      type: item.type,
      alive: item.alive,
      power: Math.random() * 5000, // Simulación de datos
      totalEnergy: Math.random() * 1000, // Simulación de datos

      lastUpdate: item.lastUpdate,
      fw: item.firmware_version_name,
      current: item.current || 0,
      voltage: item.voltage || 0,
      temperature: item.temperature || 0
    }));
  }

}
